import { Button, ButtonOwnProps, CircularProgress } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useApi } from "../contexts/ApiContext";

interface SubmitButtonProps extends ButtonOwnProps {
  onClick: () => void;
  children: React.ReactNode;
  color?:
    | "primary"
    | "secondary"
    | "blackButton"
    | "whiteButton"
    | "greyButton"
    | "redLink"
    | "blackLink"
    | "uploadButton";
  fullWidth?: boolean;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  onClick,
  children,
  color = "blackButton",
  fullWidth = true,
  ...props
}) => {
  const { isSubmitting } = useApi();
  const [buttonWidth, setButtonWidth] = useState<number | undefined>(undefined);
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  let spinnerColor = "white";
  switch (color) {
    case "whiteButton":
    case "greyButton":
      spinnerColor = "black";
      break;
    case "blackButton":
    case "redLink":
    case "blackLink":
    case "uploadButton":
      spinnerColor = "white";
      break;
    default:
      spinnerColor = "white";
  }

  useEffect(() => {
    if (buttonRef.current) {
      setButtonWidth(buttonRef.current.offsetWidth);
    }
  }, []);

  return (
    <Button
      ref={buttonRef}
      {...props}
      fullWidth={fullWidth}
      color={color}
      onClick={onClick}
      disabled={props?.disabled || isSubmitting}
      sx={{ width: buttonWidth, ...(props.sx || {}) }}
    >
      {isSubmitting ? (
        <CircularProgress
          sx={{ paddingY: 1, paddingX: 1, color: spinnerColor }}
        />
      ) : (
        children
      )}
    </Button>
  );
};

export default SubmitButton;
